import { Box, Button, Grid2 as Grid, Typography } from '@mui/material'

const ButtonContent = () => {
    return (
        <Grid container spacing={2}>
            <Grid size={12}>
                <Typography variant="h3" gutterBottom>
                    Buttons
                </Typography>
                <code>{`<Button>Default Button</Button>`}</code>
                <br />
                <code>{`<Button variant="contained">Contained Variant</Button>`}</code>
                <br />
                <code>{`<Button variant="outlined">Outlined Variant</Button>`}</code>
                <br />
                <code>{`<Button variant="text">Text Variant</Button>`}</code>
                <br />
            </Grid>
            <Grid size={3}>
                <Box>
                    <Box>
                        <b>Default</b>
                    </Box>
                    <Box>
                        <Button>Default Button</Button>
                    </Box>
                </Box>
            </Grid>
            <Grid size={3}>
                <Box>
                    <Box>
                        <b>Contained Variant</b>
                    </Box>
                    <Box>
                        <Button variant="contained">Contained Variant</Button>
                    </Box>
                </Box>
            </Grid>
            <Grid size={3}>
                <Box>
                    <Box>
                        <b>Outlined Variant</b>
                    </Box>
                    <Box>
                        <Button variant="outlined">Outlined Variant</Button>
                    </Box>
                </Box>
            </Grid>
            <Grid size={3}>
                <Box>
                    <Box>
                        <b>Text Variant</b>
                    </Box>
                    <Box>
                        <Button variant="text">Text Variant</Button>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    )
}

export default {
    content: <ButtonContent />,
    slug: 'buttons',
    title: 'Buttons'
}
